export const POLLS_INPUT_MAX_LENGTH = 512;
